import { AuthService } from '../auth.service';
import { inject } from '@angular/core';
import {
  Router,
  ActivatedRouteSnapshot,
  CanActivateFn,
  RouterStateSnapshot
} from '@angular/router';
import { switchMap, map } from 'rxjs/operators';
import { of, from } from 'rxjs';

export const NoAuthGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  return authService.check().pipe(
    switchMap(isAuthenticated => {
      if (isAuthenticated) {
        // Check if there's a beta invite token in query params
        const inviteToken = route.queryParams['invite'];

        if (inviteToken) {
          // If user is authenticated and has beta invite, redirect to subscriptions page
          // This allows logged-in users to use beta invite for plan selection
          return from(
            router.navigate(['/settings'], {
              queryParams: { section: 'subscriptions', invite: inviteToken }
            })
          ).pipe(map(() => false));
        }

        // No beta invite - redirect to home
        return from(router.navigate(['/'])).pipe(map(() => false));
      }
      return of(true);
    })
  );
};
